import { Check, Clock, MessageSquareWarning } from "lucide-react";
import { cn } from "@/lib/utils";

const STATUS_CLS = {
  in_review: "bg-amber-50 text-amber-800 border-amber-200", noted: "bg-orange-50 text-orange-800 border-orange-200",
  open: "bg-sky-50 text-sky-800 border-sky-200", in_progress: "bg-indigo-50 text-indigo-800 border-indigo-200",
  done: "bg-emerald-50 text-emerald-800 border-emerald-200", cancelled: "bg-slate-100 text-slate-500 border-slate-200",
};
const PRIORITY_CLS = { High: "bg-red-50 text-red-700 border-red-200", Medium: "bg-amber-50 text-amber-700 border-amber-200", Low: "bg-slate-50 text-slate-600 border-slate-200" };

export const StatusPill = ({ t, testid }) => (
  <span className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold", STATUS_CLS[t.status])} data-testid={testid}>{t.status_label}</span>
);

export const PriorityPill = ({ p, testid }) => (
  <span className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold", PRIORITY_CLS[p])} data-testid={testid}>{p}</span>
);

const STATE = { endorsed: ["bg-emerald-50 text-emerald-800 border-emerald-200", Check], noted: ["bg-orange-50 text-orange-800 border-orange-200", MessageSquareWarning], pending: ["bg-white text-slate-500 border-slate-200", Clock] };

export const ReviewerChips = ({ reviewers, testid }) => (
  <div className="flex flex-wrap gap-1" data-testid={testid}>
    {reviewers.map((r) => {
      const [cls, Icon] = STATE[r.state];
      return (
        <span key={r.id} className={cn("inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium", cls)} title={r.state === "pending" ? "Waiting for review" : r.state === "endorsed" ? "Endorsed" : "Noted"} data-testid={`${testid}-${r.id}`}>
          <Icon className="h-3 w-3" /> {r.name}
        </span>
      );
    })}
  </div>
);
